import { inject, signal } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { Ipast } from "../../../models/ipast";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../../environments/environment";
import { AlertMessageService } from "../alert-msg/message.service";
import { catchError, of } from "rxjs";

export const pastpapersResolver: ResolveFn<any> = (route, state) => {
  const subjectSlug = signal(route.paramMap.get("sub") ?? "");
  const curriculumSlug = signal(route.paramMap.get("cur") ?? "");
  const _alertMessageService = inject(AlertMessageService);
  const _httpClient = inject(HttpClient);
  const baseUrl = environment.apiUrl;

  return _httpClient.get<Ipast>(`${baseUrl}api/website/subjects/${subjectSlug()}/pastpapers?curriclum_slug=${curriculumSlug()}`) .pipe(
    catchError((err) => {
      _alertMessageService.addMsg(err?.error?.msg || "Error loading Pastpapers data");
      return of(undefined);
    }),
  );;
};
